import {createContext} from 'react'


const ModalFormContext = createContext({  
    isModalOpen : false,
    modalForm : null,
    forms : [],
    setModalForm : () => {},
});

export default ModalFormContext;
